"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconSocialPinterest.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSocialPinterest = function IconSocialPinterest(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.96 2.219a9.963 9.963 0 0 0-9.788 8.117A9.962 9.962 0 0 0 8.328 21.46c-.09-.785-.164-2 .035-2.86.18-.78 1.164-4.953 1.164-4.953a3.616 3.616 0 0 1-.297-1.476c0-1.383.805-2.422 1.805-2.422.852 0 1.262.64 1.262 1.402 0 .852-.54 2.125-.828 3.32-.239.993.5 1.801 1.476 1.801 1.77 0 3.133-1.875 3.133-4.554 0-2.387-1.715-4.051-4.168-4.051-2.836 0-4.5 2.125-4.5 4.32 0 .852.328 1.77.738 2.27a.3.3 0 0 1 .067.289c-.074.312-.25.992-.281 1.125-.04.18-.145.219-.332.129-1.25-.582-2.028-2.395-2.028-3.86 0-3.14 2.281-6.027 6.582-6.027 3.453 0 6.14 2.461 6.14 5.75 0 3.438-2.163 6.2-5.163 6.2-1.008 0-1.961-.524-2.278-1.15l-.625 2.376c-.222.867-.832 1.953-1.238 2.613a9.97 9.97 0 0 0 12.023-13.61 9.973 9.973 0 0 0-9.058-5.89Zm0 0",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconSocialPinterest.displayName = "IconSocialPinterest";
var _default = IconSocialPinterest;
exports["default"] = _default;
//# sourceMappingURL=IconSocialPinterest.js.map